import { render, staticRenderFns } from "./DayBookingDetails.vue?vue&type=template&id=a4fb9ada&scoped=true&"
import script from "./DayBookingDetails.vue?vue&type=script&lang=ts&"
export * from "./DayBookingDetails.vue?vue&type=script&lang=ts&"
import style0 from "./DayBookingDetails.vue?vue&type=style&index=0&id=a4fb9ada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fb9ada",
  null
  
)

export default component.exports